export default function ConnectionFlow() {
  const steps = [
    {
      title: 'One Narrative Foundation',
      description: 'Both programs are built on the same Five Elements mythology and Broken Seal universe — ensuring narrative continuity across competition and corporate experiences.',
      icon: 'ri-book-2-line',
      color: 'from-purple-500 to-purple-600'
    },
    {
      title: 'One Technology Engine',
      description: 'Both experiences use the same Unreal Engine environments, motion capture systems, AI choreography tools and digital reward frameworks.',
      icon: 'ri-cpu-line',
      color: 'from-cyan-400 to-blue-500'
    },
    {
      title: 'Two Entry Points',
      description: 'Ultimate Freestyle War engages audiences, artists, media and sponsors.\n\nElemental Harmony Workshop engages corporates, leadership teams and enterprises.\n\nBoth feed into the same cultural and digital ecosystem.',
      icon: 'ri-route-line',
      color: 'from-orange-500 to-orange-600'
    }
  ];

  return (
    <section className="py-32 bg-[#0A0A0F] relative overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-cyan-400 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-orange-500 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <h2 className="text-5xl md:text-6xl font-bold text-white text-center mb-20">
          How The Two Experiences Are Connected
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative">
          {/* Connection Lines */}
          <div className="hidden md:block absolute top-32 left-0 right-0 h-0.5 bg-gradient-to-r from-purple-500 via-cyan-400 to-orange-500 opacity-30"></div>

          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Step Number Badge */}
              <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-12 h-12 rounded-full bg-gradient-to-br ${step.color} flex items-center justify-center text-white font-bold text-xl shadow-lg z-20">
                {index + 1}
              </div>

              {/* Card */}
              <div className="bg-gradient-to-b from-[#1A1A2E] to-[#0F0F1A] rounded-3xl p-10 pt-14 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 h-full">
                {/* Icon */}
                <div className={`w-20 h-20 rounded-full bg-gradient-to-br ${step.color} flex items-center justify-center mb-8 mx-auto`}>
                  <i className={`${step.icon} text-4xl text-white`}></i>
                </div>

                {/* Title */}
                <h3 className="text-2xl font-bold text-white text-center mb-6">
                  {step.title}
                </h3>

                {/* Description */}
                <div className="text-gray-300 text-base leading-relaxed text-center space-y-3">
                  {step.description.split('\n\n').map((paragraph, i) => (
                    <p key={i}>{paragraph}</p>
                  ))}
                </div>
              </div>

              {/* Arrow Connector */}
              {index < steps.length - 1 && (
                <div className="hidden md:flex absolute top-32 -right-6 items-center justify-center z-10">
                  <i className="ri-arrow-right-line text-3xl text-cyan-400 opacity-50"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Bottom Statement */}
        <div className="mt-24 text-center">
          <div className="inline-block bg-gradient-to-r from-purple-500/10 via-cyan-400/10 to-orange-500/10 rounded-2xl px-12 py-8 border border-cyan-400/20">
            <p className="text-2xl md:text-3xl font-serif italic bg-gradient-to-r from-purple-400 via-cyan-400 to-orange-400 bg-clip-text text-transparent">
              Different audiences. Different objectives. One unified platform.
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <a 
            href="#contact" 
            className="inline-flex items-center gap-3 px-10 py-4 bg-gradient-to-r from-orange-500 to-orange-600 rounded-full text-white font-bold text-lg hover:shadow-2xl hover:shadow-orange-500/50 transition-all hover:-translate-y-1 cursor-pointer whitespace-nowrap"
          >
            Bring This Experience to Your Team
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
